import './HomePage.css';
import { useAuth } from '../utils/AuthContext';
import { useLanguage } from '../utils/LanguageContext';
import translations from './HomePage.lang.json';
import BackgroundImage from '../images/homepage_fadedDollarSign.svg';
import DollarSignSymbol from '../images/dollarsignSymbol.svg';
import StockGraphIcon from '../images/stockGraphIcon.svg';
import marketingTranslations from '../components/MarketingLeadForm.lang.json';
import { NavigateButton } from '../components/common/CommonComponents';
import { useClientParams } from '../utils/AppConfigContext';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const HomePage = () => {
  const params = useClientParams();
  const { lang } = useLanguage(translations, marketingTranslations);
  const { isLoggedIn } = useAuth();

  const location = useLocation();
  //TODO: Scale this code across site to set user to top of page everytime they're routed to a new page
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <main className="homepage-container">
      <div className="homepage-top-section">
        <div className="background-image-container">
          <img src={BackgroundImage} alt="Background" className="background-image" />
          <h2 className="page-title">{lang('homePageTitle')}</h2>
          <div className="overlay-content">
            <h3>{lang('selfFundedSignupButton')}</h3>
            {params.MARKETING_MODE ? (
              <NavigateButton to="/register" type="primary">
                {lang('registerButton')}
              </NavigateButton>
            ) : (
              <NavigateButton to="/signup" type="primary">
                {lang('createAccount')}
              </NavigateButton>
            )}
          </div>
        </div>
        <div className="admin-card">
          <div className="admin-card-text">
            <h3>{lang('adminHomepageRouteButtonExplanation')}</h3>
            <NavigateButton to="/admin" type="primary" className="admin-button">
              {lang('adminHomepageRouteButton')}
            </NavigateButton>
          </div>
        </div>
        <div className="content-container">
          <div className="text-content">
            <div className="section1">
              <div className="section1-bullet-text">
                <img src={StockGraphIcon} alt="StockGraphIcon" className="stockGraph-icon" />
                <h3 className="section1-text">{lang(`homePageParagraph1`)}</h3>
              </div>
            </div>
            <div className="question-answer">
              <div className="qa-question">
                <img src={DollarSignSymbol} alt="Bullet" className="bullet-icon" />
                <span className="question-text">{lang('homePageParagraph2Question')}</span>
              </div>
              <div className="qa-answer">
                <span>{lang('homePageParagraph2')}</span>
              </div>
            </div>
            <div className="question-answer">
              <div className="qa-question">
                <img src={DollarSignSymbol} alt="Bullet" className="bullet-icon" />
                <span className="question-text">{lang('homePageParagraph3Question')}</span>
              </div>
              <div className="qa-answer">
                <span>{lang('homePageParagraph3')}</span>
              </div>
            </div>
            <div className="question-answer">
              <div className="qa-question">
                <img src={DollarSignSymbol} alt="Bullet" className="bullet-icon" />
                <span className="question-text">{lang('homePageParagraph4Question')}</span>
              </div>
              <div className="qa-answer">
                <span>{lang('homePageParagraph4')}</span>
              </div>
            </div>
            {!isLoggedIn && (
              <div className="call-to-action">
                <h3>{lang(`getStarted`)}</h3>
                {params.MARKETING_MODE ? (
                  <NavigateButton to="/register" type="primary">
                    {lang('registerButton')}
                  </NavigateButton>
                ) : (
                  <NavigateButton to="/signup" type="primary">
                    {lang('createAccount')}
                  </NavigateButton>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </main>
  );
};

export default HomePage;
